import * as types from "./actionTypes";
import { showAlertSuccess } from "./alertActions";
import taxCodeService from "../services/taxCodeService";

export function loadTaxCodesSuccess(codes) {
  return {
    type: types.LOAD_TAX_CODES_SUCCESS,
    codes
  };
}

export function loadTaxCodes() {
  return (dispatch) =>
    taxCodeService
      .loadTaxCodes()
      .then((data) => dispatch(loadTaxCodesSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}
